import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useQuery, useMutation } from "@apollo/client";
// Import your GraphQL queries and mutations
import swal from "sweetalert";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";

import { loanManagementUrl, setupManagementUrl } from "../../../config";
import { executeAnyMutation } from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const loan_url = loanManagementUrl.uri;
// const loan_url ="https://localhost:7113/GraphQL " ;

const ActiveLoanReversalForm = (props) => {
  const initialValues = {
    loanId: "",
  };

  const validationSchema = yup.object().shape({
    loanId: yup.string().required("Loan Id is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { loanId } = values;
      const variables = { loanId, status: 3 };

      const response = await executeAnyMutation(
        props.isEditing ? "" : "approveRejectActiveLoanReversal",
        variables,
        "param",
        false,
        loan_url
      );
      const parsedResponse = JSON.parse(response?.results);
      if (
        parsedResponse ==
        "Loan reversal initiated successfully, please approve or reject it here in actions"
      ) {
        props.onAction();
        props.onClose();
        Swal.fire(
          "Succes!",
          `Loan reversal has been initiated successfully`,
          "success"
        );
      } else {
        props.onClose();
        Swal.fire("Error!", "Please contact the Admin.", "error");
      }
    } catch (error) {
      console.error("Error:", error.message);
    }

    // Set submitting to false to indicate the form submission is complete
    setSubmitting(false);

    // Close the modal or perform any other actions after submission
  };

  return (
    <Box m="20px">
      <Header
        title={"Initiate Loan Reversal"}
        subtitle={"Fill the form below to initiate a loan reversal"}
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Loan Id*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.loanId}
                name="loanId"
                error={touched.loanId && !!errors.loanId}
                helperText={touched.loanId && errors.loanId}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default ActiveLoanReversalForm;
